export const dealersTransporterSubMenu = [{
  path: '/dealers-transporters/list/:dealerId(\\d+)',
  component: () => import('@/views/dealers-transporters/list.vue'),
  name: 'orderManagement.transporter.title',
  meta: {
    title: 'orderManagement.transporter.title',
    icon: 'user',
    noCache: true,
    hidden: true
  }
}, {
  path: '/dealers-transporters/add/:dealerId(\\d+)',
  component: () => import('@/views/dealers-transporters/manage.vue'),
  name: 'orderManagement.transporter.add',
  props: {
    isEdit: false
  },
  meta: {
    roles: ['Super Admin', 'Admin'],
    title: 'orderManagement.transporter.add',
    noCache: true,
    activeMenu: '/dealers-transporters/list/:dealerId(\\d+)',
    hidden: true
  }
}, {
  path: '/dealers-transporters/edit/:id(\\d+)',
  component: () => import('@/views/dealers-transporters/manage.vue'),
  name: 'orderManagement.transporter.edit',
  props: {
    isEdit: true
  },
  meta: {
    roles: ['Super Admin', 'Admin'],
    title: 'orderManagement.transporter.edit',
    noCache: true,
    activeMenu: '/dealers-transporters/list/:dealerId(\\d+)',
    hidden: true
  }
}];